module.exports = __webpack_public_path__ + "img/Expand.0bafa017.svg";